'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _components = require('components');

var _modals = require('constants/modals');

var _modals2 = require('redux/modules/modals');

var _templates = require('redux/modules/templates');

var _shallowEqual = require('redux/utils/shallowEqual');

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _templatesSettings = require('redux/modules/templates/templatesSettings');

var _notifications = require('redux/modules/notifications');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplateConfigurationSubHeader = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(TemplateConfigurationSubHeader, _Component);

  function TemplateConfigurationSubHeader() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TemplateConfigurationSubHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TemplateConfigurationSubHeader.__proto__ || (0, _getPrototypeOf2.default)(TemplateConfigurationSubHeader)).call.apply(_ref, [this].concat(args))), _this), _this._onSave = function () {
      var templateSettings = _this.props;
      var templatesList = _this.props.templates;
      templatesList = (0, _keys2.default)(templatesList).map(function (key) {
        return templatesList[key];
      });
      var templateValidation = (0, _templatesSettings.validateTemplateSettings)(templateSettings);

      if (templateValidation.validated === false) {
        //NOTIFICATION
        _this.props.errorPopUp({
          title: 'Error',
          message: templateValidation.msg
          //position: 'tr'
        });
      } else {
        var template = _this.props.template;

        _this.props.saveTemplate((0, _stringify2.default)(template), _this.props.codedToken);
      }
    }, _this._onCancel = function () {
      var _this$props = _this.props,
          template = _this$props.template,
          unmodifiedTemplate = _this$props.unmodifiedTemplate;


      if (template && (template.isNew || !(0, _shallowEqual2.default)(template, unmodifiedTemplate))) {
        var confirmMessage = 'ALL CHANGES WILL BE LOST, ARE YOU SURE YOU WANT TO CONTINUE?';
        _this.props.showModal(_modals.CONFIRM, {
          body: confirmMessage,
          onCancel: function onCancel() {
            return _this.props.hideModal(_modals.CONFIRM);
          },
          onConfirm: function onConfirm() {
            _this.props.hideModal(_modals.CONFIRM);
            _this.props.cancelTemplateConfiguration();
          }
        });
      } else {
        _this.props.cancelTemplateConfiguration();
      }
    }, _this._onDelete = function () {
      var template = _this.props.template;


      if (template && template.id) {
        var confirmMessage = 'CURRENT TEMPLATE WILL BE DELETED, ARE YOU SURE YOU WANT TO CONTINUE?';
        _this.props.showModal(_modals.CONFIRM, {
          body: confirmMessage,
          onCancel: function onCancel() {
            return _this.props.hideModal(_modals.CONFIRM);
          },
          onConfirm: function onConfirm() {
            _this.props.hideModal(_modals.CONFIRM);
            _this.props.deleteTemplateConfiguration(template.id, _this.props.codedToken);
          }
        });
      }
    }, _this._onReset = function () {
      var _this$props2 = _this.props,
          template = _this$props2.template,
          unmodifiedTemplate = _this$props2.unmodifiedTemplate;


      if (template && (template.isNew || !(0, _shallowEqual2.default)(template, unmodifiedTemplate))) {
        var confirmMessage = 'ALL CHANGES WILL BE LOST, ARE YOU SURE YOU WANT TO CONTINUE?';
        _this.props.showModal(_modals.CONFIRM, {
          body: confirmMessage,
          onCancel: function onCancel() {
            return _this.props.hideModal(_modals.CONFIRM);
          },
          onConfirm: function onConfirm() {
            _this.props.hideModal(_modals.CONFIRM);
            _this.props.resetTemplateConfiguration();
          }
        });
      } else {
        _this.props.resetTemplateConfiguration();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TemplateConfigurationSubHeader, [{
    key: 'render',
    value: function render() {
      var BTN_SIZES = _components.ENTERPRISE_BUTTON_SIZES;
      var BTN_TYPES = _components.ENTERPRISE_BUTTON_TYPES;
      var styles = require('./TemplateConfigurationSubHeader.scss');

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('enterprise-subHeader__root', styles.root) },
        _react2.default.createElement(
          'h1',
          { className: (0, _classnames2.default)('enterprise-subHeader__title', styles.title) },
          'Template Configuration'
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('enterprise-subHeader__actionsWrapper', styles.actionsWrapper) },
          _react2.default.createElement(
            _components.EnterpriseButton,
            {
              className: (0, _classnames2.default)('enterprise-subHeader__action', styles.action),
              size: BTN_SIZES.MEDIUM,
              type: BTN_TYPES.PRIMARY,
              onClick: this._onSave
            },
            'SAVE'
          ),
          _react2.default.createElement(
            _components.EnterpriseButton,
            {
              className: (0, _classnames2.default)('enterprise-subHeader__action', styles.action),
              size: BTN_SIZES.MEDIUM,
              type: BTN_TYPES.WARNING,
              onClick: this._onReset
            },
            'RESET'
          ),
          _react2.default.createElement(
            _components.EnterpriseButton,
            {
              className: (0, _classnames2.default)('enterprise-subHeader__action', styles.action),
              size: BTN_SIZES.MEDIUM,
              type: BTN_TYPES.DANGER,
              onClick: this._onDelete
            },
            'DELETE'
          ),
          _react2.default.createElement(
            _components.EnterpriseButton,
            {
              className: (0, _classnames2.default)('enterprise-subHeader__action', styles.action),
              size: BTN_SIZES.MEDIUM,
              type: BTN_TYPES.SECONDARY,
              onClick: this._onCancel
            },
            'CANCEL'
          )
        )
      );
    }
  }]);
  return TemplateConfigurationSubHeader;
}(_react.Component), _class.propTypes = {
  codedToken: _react.PropTypes.string,
  deleteTemplateConfiguration: _react.PropTypes.func,
  saveTemplate: _react.PropTypes.func,
  cancelTemplateConfiguration: _react.PropTypes.func,
  resetTemplateConfiguration: _react.PropTypes.func,
  template: _react.PropTypes.object,
  templates: _react.PropTypes.object,
  unmodifiedTemplate: _react.PropTypes.object,
  showModal: _react.PropTypes.func,
  hideModal: _react.PropTypes.func
}, _temp2);


var mapStateToProps = function mapStateToProps(state) {
  var _state$templateApplic = state.templateApplication.templates,
      currentTemplate = _state$templateApplic.currentTemplate,
      currentTemplateUnmodified = _state$templateApplic.currentTemplateUnmodified,
      templates = _state$templateApplic.templates;


  return {
    codedToken: state.auth.codedToken,
    template: currentTemplate,
    unmodifiedTemplate: currentTemplateUnmodified,
    templates: templates
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  deleteTemplateConfiguration: _templates.deleteTemplateConfiguration.base,
  saveTemplate: _templates.saveTemplate.base,
  cancelTemplateConfiguration: _templates.cancelTemplateConfiguration,
  resetTemplateConfiguration: _templates.resetTemplateConfiguration,
  showModal: _modals2.show,
  hideModal: _modals2.hide,
  errorPopUp: _notifications.error
})(TemplateConfigurationSubHeader);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateConfiguration/TemplateConfigurationSubHeader/TemplateConfigurationSubHeader.jsx
// module id = 1643
// module chunks = 0